import BaseDirectories from '../../../base directories/BaseDirectories';
import Footer from './Footer';
import Header from './Header';

export default function GenderPolicy() {
  return (
    <>
      <Header />
      <div className="container lp-privacy">
        <h3 className="mt-5">TRADE LENDA GENDER POLICY</h3>

        <div className="md:p-7 md:mr-6">
          <p className="text-xxs md:text-xs text-gray07 mt-6 mb-5">
            Effective Date: January 1, 2025
          </p>
        </div>

        <div className="md:p-7 md:mr-6 mt-6 mb-5">
          <p className="text-xs text-gray07 mt-6">Introduction</p>
          <p className="text-xxs md:text-xs text-gray07 mt-6">
            Trade Lenda recognizes the critical importance of gender equality
            and the specific barriers faced by women in the workplace. We are
            committed to creating a work environment that actively protects,
            supports, and promotes the rights and well-being of women across all
            levels of our organization. This policy outlines our stance against
            gender-based discrimination, harassment, and violence while
            promoting a culture of inclusion, safety, and equity for women
            employees, partners, and stakeholders.
          </p>
        </div>

        <div className="md:p-7 md:mr-6 mt-6 mb-5">
          <p className="text-xs text-gray07 mt-6">1. Purpose</p>
          <p className="text-xxs md:text-xs text-gray07 mt-6">
            The purpose of this policy is to establish Trade Lenda's commitment
            to gender equality, inclusion, and the elimination of discrimination
            based on gender identity or expression. This policy ensures that all
            staff, partners, and stakeholders are treated with respect and
            dignity and that equal opportunity is embedded in our practices.
          </p>
          <ul>
            <li className="text-xxs md:text-xs text-gray07 mt-6">
              Ensure equal access to opportunities, resources, and leadership
              for women.
            </li>
            <li className="text-xxs md:text-xs text-gray07 mt-6">
              Protect women from discrimination, harassment, exploitation, and
              violence.
            </li>
            <li className="text-xxs md:text-xs text-gray07 mt-6">
              Promote women's participation in decision-making processes.
            </li>
            <li className="text-xxs md:text-xs text-gray07 mt-6">
              Support the personal, professional, and social development of
              women.
            </li>
            <li className="text-xxs md:text-xs text-gray07 mt-6">
              Establish accountability for upholding women's rights and
              well-being within the organization.
            </li>
          </ul>
        </div>

        <div className="md:p-7 md:mr-6 mt-6 mb-5">
          <p className="text-xs text-gray07 mt-6">2. Scope</p>
          <p className="text-xxs md:text-xs text-gray07 mt-6">
            This policy applies to all employees, contractors, consultants,
            volunteers, partners, and anyone acting on behalf of Trade Lenda in
            all work-related activities, locations, and communications.
          </p>
        </div>

        <div className="md:p-7 md:mr-6 mt-6 mb-5">
          <p className="text-xs text-gray07 mt-6">3. Policy Statement</p>
          <p className="text-xxs md:text-xs text-gray07 mt-6">
            Trade Lenda is committed to:
          </p>
          <ul>
            <li className="text-xxs md:text-xs text-gray07 mt-6">
              Creating a workplace free from gender-based discrimination and
              harassment.
            </li>
            <li className="text-xxs md:text-xs text-gray07 mt-6">
              Providing equal access to recruitment, training, promotions, and
              leadership opportunities.
            </li>
            <li className="text-xxs md:text-xs text-gray07 mt-6">
              Promoting gender balance across departments and leadership levels.
            </li>
            <li className="text-xxs md:text-xs text-gray07 mt-6">
              Supporting inclusive policies and practices for all genders,
              including non-binary and transgender individuals.
            </li>
            <li className="text-xxs md:text-xs text-gray07 mt-6">
              Encouraging work-life balance and family-friendly work
              environments.
            </li>
            <li className="text-xxs md:text-xs text-gray07 mt-6">
              Fostering gender-sensitive communication and language.
            </li>
            <li className="text-xxs md:text-xs text-gray07 mt-6">
              Promote Zero Tolerance for sexual harassment, discrimination, or
              abuse against women.
            </li>
            <li className="text-xxs md:text-xs text-gray07 mt-6">
              Ensure affirmative action to address gender imbalances in
              recruitment and leadership.
            </li>
            <li className="text-xxs md:text-xs text-gray07 mt-6">
              Confidentiality and Protection for women reporting misconduct.
            </li>
            <li className="text-xxs md:text-xs text-gray07 mt-6">
              Recognize the multiple and overlapping forms of discrimination
              women may face (e.g., based on race, age, disability, marital
              status).
            </li>
            <li className="text-xxs md:text-xs text-gray07 mt-6">
              Promote Women-centred approaches to leadership development,
              health, safety, and well-being.
            </li>
          </ul>
        </div>

        <div className="md:p-7 md:mr-6 mt-6 mb-5">
          <p className="text-xs text-gray07 mt-6">4. Objectives</p>
          <ul>
            <li className="text-xxs md:text-xs text-gray07 mt-6">
              To eliminate gender-based barriers to participation and
              progression.
            </li>
            <li className="text-xxs md:text-xs text-gray07 mt-6">
              To mainstream gender perspectives in organizational planning,
              decision-making, and programs.
            </li>
            <li className="text-xxs md:text-xs text-gray07 mt-6">
              To collect and analyze sex-disaggregated data for program
              monitoring and evaluation.
            </li>
            <li className="text-xxs md:text-xs text-gray07 mt-6">
              To ensure safe reporting mechanisms for gender-based
              discrimination and harassment.
            </li>
          </ul>
        </div>

        <div className="md:p-7 md:mr-6 mt-6 mb-5">
          <p className="text-xs text-gray07 mt-6">
            5. Roles and Responsibilities
          </p>
          <div className="overflow-x-auto">
            <table className="min-w-full border border-gray-300">
              <thead>
                <tr>
                  <th className="border border-gray-300 px-4 py-2 text-xs text-gray07">
                    Role
                  </th>
                  <th className="border border-gray-300 px-4 py-2 text-xs text-gray07">
                    Responsibility
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border border-gray-300 px-4 py-2 text-xxs md:text-xs text-gray07">
                    Management
                  </td>
                  <td className="border border-gray-300 px-4 py-2 text-xxs md:text-xs text-gray07">
                    Lead by example, enforce the policy, and ensure compliance
                  </td>
                </tr>
                <tr>
                  <td className="border border-gray-300 px-4 py-2 text-xxs md:text-xs text-gray07">
                    HR Department
                  </td>
                  <td className="border border-gray-300 px-4 py-2 text-xxs md:text-xs text-gray07">
                    Integrate gender equality in hiring, training, and grievance
                    handling.
                  </td>
                </tr>
                <tr>
                  <td className="border border-gray-300 px-4 py-2 text-xxs md:text-xs text-gray07">
                    Employees
                  </td>
                  <td className="border border-gray-300 px-4 py-2 text-xxs md:text-xs text-gray07">
                    Respect and uphold the principles of this policy.
                  </td>
                </tr>
                <tr>
                  <td className="border border-gray-300 px-4 py-2 text-xxs md:text-xs text-gray07">
                    Gender Focal Person
                  </td>
                  <td className="border border-gray-300 px-4 py-2 text-xxs md:text-xs text-gray07">
                    Monitor gender integration, collect data, and report
                    progress.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="md:p-7 md:mr-6 mt-6 mb-5">
          <p className="text-xs text-gray07 mt-6">
            6. Implementation Strategies
          </p>
          <ul>
            <li className="text-xxs md:text-xs text-gray07 mt-6">
              Conduct periodic gender sensitivity training.
            </li>
            <li className="text-xxs md:text-xs text-gray07 mt-6">
              Integrate gender analysis into projects and organizational
              decisions.
            </li>
            <li className="text-xxs md:text-xs text-gray07 mt-6">
              Ensure gender parity targets in recruitment and leadership
              pipelines.
            </li>
            <li className="text-xxs md:text-xs text-gray07 mt-6">
              Establish confidential reporting and grievance redress mechanisms.
            </li>
            <li className="text-xxs md:text-xs text-gray07 mt-6">
              Support flexible work arrangements and parental leave policies.
            </li>
          </ul>
        </div>

        <div className="md:p-7 md:mr-6 mt-6 mb-5">
          <p className="text-xs text-gray07 mt-6">7. Monitoring & Evaluation</p>
          <p className="text-xxs md:text-xs text-gray07 mt-6">
            Trade Lenda will track progress using indicators such as:
          </p>
          <ul>
            <li className="text-xxs md:text-xs text-gray07 mt-6">
              Gender balance in staff composition and leadership roles
            </li>
            <li className="text-xxs md:text-xs text-gray07 mt-6">
              Number of gender-related complaints and resolutions
            </li>
            <li className="text-xxs md:text-xs text-gray07 mt-6">
              Employee satisfaction surveys on inclusiveness
            </li>
            <li className="text-xxs md:text-xs text-gray07 mt-6">
              Program impact disaggregated by gender
            </li>
          </ul>
        </div>

        <div className="md:p-7 md:mr-6 mt-6 mb-5">
          <p className="text-xs text-gray07 mt-6">8. Review and Updates</p>
          <p className="text-xxs md:text-xs text-gray07 mt-6">
            This policy will be reviewed every two years or as needed to reflect
            emerging best practices or organizational changes.
          </p>
        </div>

        <div className="mb-3 ceo" style={{}}>
          <div className="">
            <p className="text-xs text-gray07 mt-6">9. Approval</p>
            <p className="text-xxs md:text-xs text-gray07 mt-6 fw-semibold">
              Authorized by: Adeshina Adewumi
            </p>
          </div>
          <div className="" style={{ height: '100%' }}>
            <span className="text-xxs md:text-xs text-gray07 mt-6">
              {' '}
              Signature:
              <img
                src={`${BaseDirectories.IMAGES_DIR}/Adeshina Signature-01.png`}
                style={{ width: '130px', top: '10em', left: '10px' }}
                alt=""
              />
            </span>
          </div>

          <br />
          <h6> Date: 01 January 2025</h6>
        </div>
      </div>
      <Footer />
    </>
  );
}
